import { ButtonCheckbox } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { type WiggleType } from '@/defs/input'
import { COLOR_LABELS, COLORS, type ColorType } from '@/defs/mtg'
import { toggleColor } from '@/utils/cardUtil'

import styles from './InputColors.module.scss'

type Props = {
  borderColor?: 'warning'
  colors: ColorType[]
  onChange: (colors: ColorType[]) => void
  wiggle?: WiggleType
}

export const InputColors = ({ borderColor, colors, onChange, wiggle }: Props) => (
  <div className={styles.container}>
    {COLORS.map((c) => (
      <ButtonCheckbox
        aria-label={COLOR_LABELS[c].label}
        borderColor={borderColor}
        key={c}
        onClick={() => onChange(toggleColor({ color: c, colors }))}
        selected={colors.includes(c)}
        size='sm'
        type='button'
        variant='stacked'
        wiggle={wiggle}
      >
        <Icon name={COLOR_LABELS[c].icon} />
      </ButtonCheckbox>
    ))}
  </div>
)
